// import React from "react";

// const statusColors = {
//   pending: "bg-yellow-100 text-yellow-800 border border-yellow-300",
//   approved: "bg-green-100 text-green-800 border border-green-300",
//   rejected: "bg-red-100 text-red-800 border border-red-300",
// };

// const StatusBadge = ({ status }) => {
//   const normalizedStatus = status?.toLowerCase();
//   const colorClass = statusColors[normalizedStatus] || "bg-gray-100 text-gray-800 border border-gray-300";

//   return (
//     <span
//       className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap capitalize ${colorClass}`}
//     >
//       {status}
//     </span>
//   );
// };

// export default StatusBadge;

import React from "react";

const statusColors = {
  pending: "bg-yellow-200 text-yellow-800 shadow-md",
  approved: "bg-green-100 text-green-800 shadow-md",
  active: "bg-green-100 text-green-800 shadow-md",
  inactive: "bg-gray-100 text-gray-800 shadow-md",
  rejected: "bg-red-100 text-red-800 shadow-md",
  draft: "bg-gray-100 text-gray-800 shadow-md",
  paid: "bg-blue-100 text-blue-800 shadow-md",
  processed: "bg-purple-100 text-purple-800 shadow-md",
  generated: "bg-indigo-100 text-indigo-800 shadow-md",
  processing: "bg-orange-100 text-orange-800 shadow-md",
};

const StatusBadge = ({ status }) => {
  const normalizedStatus = status?.toLowerCase();
  const colorClass = statusColors[normalizedStatus] || "bg-gray-100 text-gray-800 border border-gray-300";
  
  return (
    <span
      className={`px-3 py-1 rounded-xl text-xs font-medium whitespace-nowrap capitalize ${colorClass}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;